var map = {
	"./favicon-SPM.ico": 652,
	"./favicon-divino-amor copy.ico": 653,
	"./favicon-divino-amor.ico": 654,
	"./favicon-g-encontros.ico": 655,
	"./favicon-match.ico": 656,
	"./favicon-our-time.ico": 657,
	"./favicon-par-perfeito.ico": 658,
	"./favicon-single-parent-meet.ico": 659,
	"./favicon-stir.ico": 660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 651;